// Slovenská jazyková mutácia. Plný preklad českej vetvy.
// Maintainerom odporúčame, aby tento súbor pri ďalších úpravách udržiavali v zhode so štruktúrou cs vetvy v translations.js.

export const skTranslations = {
  nav: {
    home: "Domov",
    pillars: "Naše služby",
    instore: "Instore Data",
    admin: "Admin",
    contact: "Kontakt",
    about: "O nás",
  },
  common: {
    learnMore: "Zistiť viac",
    comingSoon: "Pripravujeme",
    backHome: "Späť na úvod",
    czech: "CZ",
    slovak: "SK",
    english: "EN",
  },
  home: {
    eyebrow: "Budúcnosť retailu / Future of retail",
    heroTitle: "Reálne dáta z predajní. Reálna prevaha pri rokovaní.",
    heroSub:
      "Global Marketing je prevádzkovateľom vlastných systémov na zber a analýzu instore dát. Nepracujeme s odhadmi — pracujeme s faktami z terénu.",
    heroCta1: "Preskúmať Instore Data",
    heroCta2: "Naše služby",
    headerCta: "Preskúmať naše služby",
    pillarsEyebrow: "Šesť pilierov / 6 Pillars",
    pillarsTitle: "Architektúra moderného merchandisingu.",
    pillarsSub:
      "Šesť vzájomne prepojených oblastí, ktorými pomáhame značkám rozhodovať sa na základe dát — nie dojmov.",
    stats: [
      { k: "1 200+", v: "monitorovaných predajní" },
      { k: "40 mil.+", v: "dátových bodov ročne" },
      { k: "99,2 %", v: "dostupnosť reportov" },
      { k: "24 h", v: "od auditu k dashboardu" },
    ],
    ctaTitle: "Pripravení na ďalší krok?",
    ctaSub: "Poďme sa porozprávať o vašej kategórii, predajniach a kampaniach. Nezáväzne.",
    ctaButton: "Kontaktujte nás",
  },
  pillars: {
    merchandising: {
      title: "Merchandising Services",
      kicker: "01",
      desc: "Komplexný merchandising naprieč CZ a SK. MERVIK + SYMES + AI report. Same-day riešenie reklamácií.",
    },
    instore: {
      title: "InStore Data",
      kicker: "02",
      desc: "Price & shelf monitoring v reálnom čase. SYMES + QlikView. Fakty namiesto dojmov.",
    },
    shelfmasters: {
      title: "Shelfmasters",
      kicker: "03",
      desc: "Outsourcing retailovej exekúcie. SLA model namiesto FTE — −66 % nákladov, merateľné KPI, žiadny lock-in.",
    },
    digital: {
      title: "RetailStore Digitalisation",
      kicker: "04",
      desc: "Digitalizácia predajne — od ESL cez IoT senzory po in-store analytiku správania.",
    },
    consulting: {
      title: "Retail Consulting",
      kicker: "05",
      desc: "Go-to-Market, vyjednávanie s reťazcami, JBP, ľudské zdroje a in-store dáta. 28+ rokov praxe.",
    },
    pos: {
      title: "POS",
      kicker: "06",
      desc: "Výroba, sklad, distribúcia a inštalácia POS materiálov. POS E-shop pre obchodné tímy. Promokalendar pre retailerov.",
    },
  },
  merchandising: {
    hero: {
      eyebrow: "Pilier 01 / Merchandising",
      title: "Vaše produkty na správnom mieste. Vždy.",
      sub:
        "Merchandising je základ každej úspešnej prítomnosti v retaile. Nestačí produkt dostať na regál — je potrebné zaistiť, aby tam bol v správnom množstve, na správnom mieste a v súlade s plánogramom aj nastavenými obchodnými podmienkami. Každý deň, v každej predajni.",
      leadIn:
        "Global Marketing zaisťuje komplexné merchandisingové služby na celom území Českej republiky a Slovenska. Pokrývame všetky obchodné reťazce aj nezávislý trh — s vlastným tímom, systémami a reportingom.",
    },
    process: {
      eyebrow: "Ako merchandising funguje",
      title: "Terén, riadenie a dáta v jednom systéme.",
      intro:
        "Každá servisná návšteva je riadená, zdokumentovaná a vyhodnotená. Proces servisnej návštevy prebieha v piatich krokoch.",
      steps: [
        { n: "01", h: "Zadanie servisu", t: "Kompletné zadanie návštevy priamo do mobilnej aplikácie MERVIK." },
        { n: "02", h: "Kontrola plochy", t: "Stav predajnej plochy, plánogram, akciové zóny a cenovky." },
        { n: "03", h: "Doplnenie tovaru", t: "Doplnenie do všetkých pozícií — primárny regál aj druhotné umiestnenia." },
        { n: "04", h: "Reporting", t: "Záznam, fotodokumentácia a štruktúrovaný report z miesta." },
        { n: "05", h: "Synchronizácia", t: "Dáta sa okamžite prenášajú do reportingového systému SYMES." },
      ],
      outro: "Výsledky sú dostupné okamžite — bez čakania, bez ručného reportovania.",
    },
    team: {
      eyebrow: "Náš tím",
      title: "Viete, kto servisuje vaše predajne. A prečo na ňom záleží.",
      intro: "Za každou zákazkou stojí konkrétny tím s jasne definovanými rolami a zodpovednosťami.",
      roles: [
        {
          h: "Key Account Manager",
          kicker: "Hlavný kontakt",
          items: [
            "Hlavný kontakt pre klienta",
            "Riadi celú zákazku, komunikuje s obchodným tímom klienta",
            "Implementuje požiadavky do praxe a zodpovedá za výsledky",
          ],
        },
        {
          h: "Regionálni manažéri",
          kicker: "Field leadership",
          items: [
            "Riadia terénny tím merchandiserov",
            "Zaisťujú školenia, náhrady, kontrolnú činnosť",
            "Priama komunikácia s obchodným tímom klienta",
          ],
        },
        {
          h: "Tím SYMES",
          kicker: "Data & reporting",
          items: [
            "Nastavuje podobu a frekvenciu reportingových výstupov",
            "Spravuje listingy, zadáva fotokampane",
            "Kontroluje kvalitu dát",
          ],
        },
      ],
    },
    quality: {
      eyebrow: "Kontrola a kvalita servisu",
      title: "Každá návšteva je doložená. Každý problém je vyriešený.",
      body: [
        "Regionálni manažéri vykonávajú pravidelné kontrolné návštevy na základe vopred definovaného mesačného plánu. Fotodokumentácia je vyhotovovaná výhradne online priamo z mobilnej aplikácie — bez fotografie nemožno servisnú návštevu ukončiť. Umožňujeme tiež klientske kontroly formou spolujazdy.",
        "Ak nastane problém, riešime ho v ten istý deň. Reklamáciu zadáte online priamo do systému SYMES — a my okamžite reagujeme. Náhradná návšteva, výmena merchandisera, eskalácia na manažéra. Žiadne čakanie do budúceho týždňa.",
      ],
      callouts: [
        { k: "100%", t: "návštev s povinnou online fotodokumentáciou" },
        { k: "Same-day", t: "riešenie reklamácií cez SYMES" },
        { k: "Spolujazda", t: "klientske kontroly v teréne" },
      ],
    },
    reporting: {
      eyebrow: "Reporting a dáta",
      title: "Viete, čo sa deje v každej predajni. V reálnom čase.",
      intro:
        "Všetky dáta zo servisných návštev sú okamžite dostupné v reportingových systémoch v štyroch podobách.",
      items: [
        {
          n: "01",
          tag: "SYMES Online",
          h: "Komplexný online prehľad 24/7",
          body:
            "Neobmedzený prístup k úplným informáciám zo servisných návštev s exportom do Excelu a fotodokumentáciou — kedykoľvek, odkiaľkoľvek.",
          list: [
            "Príznak položky: OK · OOS · STOP · NELIST · NÍZKA ZÁSOBA",
            "Cena a jej typ — bežná, akciová alebo vernostná",
            "Druhotné umiestnenia (DU) v predajni",
            "Končiaca záruka — ohrozené produkty",
            "Dotazník (definuje klient — OOS, POS materiály)",
            "Textové pole na poznámky",
            "Fotodokumentácia každej návštevy",
          ],
        },
        {
          n: "02",
          tag: "Email Summary",
          h: "Denný e-mailový prehľad o 6:00",
          body:
            "Excel sumarizácia za predchádzajúci deň zasielaná o 6:00 ráno na vami definované adresy — OOS, ceny, kontrola listingu a ďalšie parametre podľa vášho nastavenia.",
        },
        {
          n: "03",
          tag: "QlikView",
          h: "Grafická analytika svetovej triedy",
          body:
            "Asociatívna analytika — OOS podľa EAN, obchodného zástupcu, regiónu, reťazca alebo predajne. Opakujúce sa OOS a dĺžka ich trvania. Výstupné formáty PDF alebo živá licencia.",
        },
        {
          n: "04",
          tag: "AI Report · NEW",
          h: "AI analýza fotografií z predajne",
          body:
            "Absolútnou novinkou je AI report. Dáta sú reportované priamo z fotografií vyhotovených v predajni — analyzujeme všetky položky na regále, cenovky, označenie akciovej ceny a úroveň zaplnenosti regálu. Výstup vo formáte PDF.",
        },
      ],
      footer:
        "Zaškolenie na strane klienta a príprava reportingových šablón naším programátorom sú v cene servisu.",
    },
    symes: {
      eyebrow: "SYMES · náš vlastný reportingový systém",
      title: "Online softvér, ktorý zastrešuje celý servis.",
      lead:
        "SYMES je naša vlastná cloudová platforma na riadenie merchandisingových kampaní. Každá návšteva, každá položka, každá fotka — všetko v jednom systéme dostupnom klientovi 24/7. Dátový základ pre denný e-mail, QlikView analytiku aj AI report.",
      standard: {
        eyebrow: "SYMES Online · Štandardný report",
        h: "Detail návštevy so všetkým, čo klient potrebuje vedieť.",
        caption: "Detail návštevy v SYMES — Tesco / Budvar",
        items: [
          "TEXTOVÉ POLE — miesto pre poznámku z predajne",
          "PRÍZNAK PRI POLOŽKE — OK · OOS · STOP · NELIST · NÍZKA ZÁSOBA",
          "CENA A JEJ TYP — pri TOP 10 položkách klienta",
          "DRUHOTNÉ UMIESTNENIE — informácie o DU v predajni",
          "KONČIACA ZÁRUKA — produkty s ohrozenou zárukou",
          "OBJEDNÁVKA — návrh + odovzdanie zodpovednej osobe",
          "DOTAZNÍK — definuje klient (riešenie s vedúcim, dostupnosť POS …)",
          "KONTAKTOVANIE VEDÚCEHO — kedy, kto, čo",
          "FOTODOKUMENTÁCIA — vrátane GPS lokalizácie",
        ],
      },
      promo: {
        eyebrow: "SYMES Online · Monitoring promo akcií",
        h: "Akcie, ktoré naozaj prebiehajú v predajni.",
        caption: "Promo modul — fotodokumentácia druhotných umiestnení",
        items: [
          "Sledovanie promočných aktivít klienta v deň návštevy MCHD (aj mimo)",
          "Fotodokumentácia druhotných umiestnení s online reportingom do 24 hodín",
          "Okamžité riešenie nerealizovaných aktivít / druhotných umiestnení",
        ],
      },
      qlik: {
        eyebrow: "QlikView · Analytická platforma",
        h: "Grafická analýza zdrojových dát zo SYMES.",
        caption: "QlikView dashboard — asociatívna analytika",
        items: [
          "OOS podľa EAN, OZ klienta, reťazca, predajne",
          "Prehľad opakovaných OOS, počet dní v stave OOS",
          "Asociatívne filtre — kombinujte parametre ľubovoľne",
          "Výstupné formáty: PDF, Excel, live dashboard",
          "Živá licencia, zaškolenie a šablóny programátorom v cene servisu",
        ],
      },
      footer:
        "Všetky tri moduly — SYMES, e-mail summary aj QlikView — sú v cene servisu. Žiadne dodatočné licencie, žiadne ďalšie SaaS poplatky. Klient platí jednu mesačnú faktúru za servis.",
    },
    kpis: {
      eyebrow: "KPI a vyhodnocovanie",
      title: "Meriame to, na čom záleží.",
      intro:
        "Nastavíme s vami sadu kľúčových ukazovateľov, ktoré budeme pravidelne sledovať a vyhodnocovať. Základom je distribúcia, pokrytie a dostupnosť.",
      items: [
        { h: "Audit listingu", t: "Aktualizovaný audit listingu podľa jednotlivých predajní v pravidelnej frekvencii." },
        { h: "OOS analytika", t: "Analýzy OOS prostredníctvom QlikView — EAN, región, reťazec, predajňa." },
        { h: "Reporting návštev", t: "Analýza počtu návštev podľa reťazcov a lokalít, návrhy na zmeny počtu predajní alebo frekvencie." },
      ],
    },
    promo: {
      eyebrow: "Monitoring promo akcií",
      title: "Akcie, ktoré naozaj prebiehajú v predajni.",
      items: [
        "Sledovanie promočných aktivít klienta",
        "Fotodokumentácia druhotných umiestnení vrátane online reportingu",
        "Okamžité riešenie nerealizovaných aktivít / druhotných umiestnení",
      ],
    },
    onboarding: {
      eyebrow: "Ako štartujeme novú zákazku",
      title: "Rýchly štart bez zbytočnej byrokracie.",
      body: [
        "Spolupráca začína nastavením štartovacieho zoznamu predajní a frekvencie návštev. Vykonáme komplexný audit listingu na servisovaných predajniach — analýzu centrálneho listingu oproti dispozičnému listu.",
        "Na základe auditu vykonáme výber predajní, odporučíme frekvenciu návštev, nastavíme predajne a listing v systéme SYMES a pripravíme reportingové šablóny v QlikView presne podľa vašich potrieb.",
      ],
      promise: "Od prvého dňa viete, čo sa deje. A od prvého týždňa máte dáta.",
    },
    cta: {
      body: "Na základe auditu nastavíme predajne a listing v systéme SYMES a pripravíme reportingové šablóny v QlikView presne podľa vašich potrieb.",
    },
    finalCta: {
      eyebrow: "Poďme sa stretnúť",
      title: "Pripravení servisovať lepšie?",
      sub:
        "Pripravíme nezáväznú ponuku presne pre váš rozsah — reťazce, počet predajní a frekvenciu návštev.",
      button: "Kontaktovať",
      email: "info@globalmarketing.cz",
    },
  },

  instore: {
    hero: {
      eyebrow: "Pilier 02 / Instore Data",
      title: "Čo nevidíte na predajnom mieste, nemôžete riadiť.",
      sub:
        "Viete, za koľko sa váš produkt skutočne predáva? Či stojí na správnom mieste police? Či vôbec stojí na polici? A čo robí konkurencia v rovnakej chvíli v rovnakej predajni? InstoreData sú odpovede na tieto otázky — v reálnom čase, z každej predajne, prehľadne.",
      leadIn:
        "Global Marketing prevádzkuje vlastné systémy na zber, spracovanie a reporting instore dát. Nepracujeme s odhadmi — pracujeme s faktami z terénu. A sledujeme nielen vaše produkty, ale aj konkurenciu — v kategórii, ktorú nám zadáte.",
    },
    sections: {
      price: {
        eyebrow: "1 · Price Monitoring",
        title: "Viete, za koľko sa váš produkt skutočne predáva? A za koľko ho predáva konkurencia?",
        body: [
          "Skutočná cena môže byť v predajni odlišná od odporúčanej maloobchodnej ceny. Reťazce menia ceny, spúšťajú akcie, podstreľujú cenové hladiny — a pokiaľ to nesledujete v reálnom čase, prichádzate o prehľad aj o kontrolu nad vlastným cenovým positioningom.",
          "Price monitoring je systematické sledovanie skutočných cien vašich produktov aj konkurenčných značiek v predajniach v celej sieti. Výsledkom nie je len číslo — je to prehľad o tom, kde ste, kde je konkurencia a kde sú príležitosti alebo riziká.",
        ],
        checklist: [
          "Skutočné predajné ceny vašich produktov v jednotlivých predajniach a reťazcoch",
          "Porovnanie s odporúčanou maloobchodnou cenou a odhalenie cenových odchýlok",
          "Ceny konkurenčných produktov v rovnakej kategórii a v rovnakých predajniach",
          "Akciové a promočné ceny — kedy, kde a za koľko",
          "Typ ceny — bežná, akciová alebo vernostná",
          "Dlhodobé cenové trendy a sezónne výkyvy",
        ],
        footer:
          "Pokiaľ sa váš produkt pravidelne nachádza pod odporúčanou cenou v kľúčových reťazcoch, poškodzuje to váš brand positioning a sťažuje vyjednávanie s ostatnými zákazníkmi. Pokiaľ konkurencia trvalo podstreľuje vaše ceny, musíte o tom vedieť skôr, než sa to prejaví na obrate.",
      },
      shelf: {
        eyebrow: "2 · Shelf Monitoring",
        title: "Obraz o stave police je viac ako tisíc slov. Ale len vtedy, keď ho máte.",
        body: [
          "Shelf monitoring je systematické overovanie toho, ako váš produkt skutočne vyzerá na mieste predaja. Či je správne umiestnený, zodpovedá pozícii v plánograme, je dostupný a cenový štítok je na správnom mieste so správnou cenou.",
          "Terénna realita sa od dohodnutých podmienok s reťazcom líši častejšie, než by sa zdalo. Produkt môže byť presunutý na horšiu pozíciu, chýbať na sekundárnom umiestnení alebo byť prehliadnutý pri doplňovaní. Každý z týchto stavov vás stojí tržby — a bez shelf monitoringu o ňom neviete.",
        ],
        checklist: [
          "Audit umiestnenia produktu na polici — pozícia, výška, viditeľnosť",
          "Kontrola dodržiavania plánogramu a šírky sortimentu",
          "Sledovanie dostupnosti produktu — prítomnosť na polici, stav zásoby, OOS detekcia",
          "Kontrola cenových štítkov — správnosť, čitateľnosť, umiestnenie",
          "Audit sekundárnych umiestnení — čelá, displeje, promočné zóny",
          "Fotodokumentácia stavu police pre každú navštívenú predajňu",
        ],
        footer:
          "Jednorazová kontrola vám povie, ako to vyzeralo v jednej predajni jeden deň. Systematický shelf monitoring vám povie, kde sú chronické problémy, ktorí merchandiseri plnia štandardy a kde sú opakované zlyhania, ktoré je potrebné riešiť na úrovni reťazca alebo distribúcie.",
      },
      secondary: {
        eyebrow: "Druhotné umiestnenia",
        title: "Dohodli ste si druhotné umiestnenie. Ale viete, či skutočne funguje?",
        body: [
          "Druhotné umiestnenie — čelo regálu, paleta v uličke, display pri pokladni, promočný island — je jedným z najúčinnejších nástrojov na zvýšenie viditeľnosti produktu na mieste predaja. Stojí peniaze, vyžaduje vyjednávanie s reťazcom a často je súčasťou obchodných podmienok alebo JBP.",
          "Rovnako dôležité je mať prehľad o tom, čo sa deje v celej kategórii — aké druhotné umiestnenia majú vaši konkurenti, aký veľký priestor v predajni zaberajú a kde sa pohybujú voči vašim umiestneniam.",
        ],
        twoCol: [
          {
            title: "Vlastné druhotné umiestnenia",
            text:
              "Systematicky overujeme prítomnosť a stav všetkých dohodnutých druhotných umiestnení — typ, lokalita v predajni, počet facingov, stav zásoby a súlad so špecifikáciou.",
          },
          {
            title: "Konkurenčné druhotné umiestnenia",
            text:
              "Na základe zadanej kategórie monitorujeme všetky druhotné umiestnenia konkurenčných značiek — typ, počet, stav zásoby, vzdialenosť a viditeľnosť voči vašim umiestneniam.",
          },
        ],
      },
      pos: {
        eyebrow: "4 · POS materiály",
        title: "Vaša kampaň beží. Ale komunikuje skutočne na mieste predaja?",
        body: [
          "POS materiály — stojany, shelf talkery, wobblery, plagáty, nálepky, displeje — sú investíciou do komunikácie v rozhodujúcom momente. Zákazník stojí pri polici a rozhoduje sa. Pokiaľ váš POS materiál chýba, je poškodený alebo zastaraný, tá investícia prišla navnivoč.",
        ],
        twoCol: [
          {
            title: "Vlastné POS materiály",
            text:
              "Prítomnosť, stav a správnosť umiestnenia materiálov. Súlad s aktuálnou kampaňou, časovým obdobím a promočnou aktivitou.",
          },
          {
            title: "Konkurenčné POS materiály",
            text:
              "Sledujeme materiály konkurencie v kategórii, ich umiestnenie a vizuálnu výraznosť — vstup pre trade marketing aj vyjednávanie s reťazcami.",
          },
        ],
      },
      datapoints: {
        eyebrow: "Čo zbierame ku každej položke",
        title: "Dátové body pre každý EAN.",
        intro:
          "Pre každý produkt — každý EAN — zaznamenávame úplnú sadu dátových bodov, ktorá dáva zmysel nielen pre okamžitý prehľad, ale aj pre dlhodobú analytiku a vyjednávanie s reťazcami.",
        groups: [
          {
            h: "Identifikácia produktu",
            t: "EAN, názov, dodávateľ a výrobca, krajina pôvodu, sortimentná kategória a podskupina.",
          },
          {
            h: "Cenové údaje",
            t: "Aktuálna predajná cena, typ ceny — bežná, akciová alebo vernostná.",
          },
          {
            h: "Prezentácia na polici",
            t: "Počet facingov, obsah produktu, merná jednotka, typ obalu.",
          },
          {
            h: "Umiestnenie a parametre",
            t: "Označenie druhotného umiestnenia, kalibrácia, sortimentná podskupina.",
          },
        ],
      },
      mervik: {
        eyebrow: "MERVIK",
        title: "Mobilná aplikácia pre terénny reporting.",
        body:
          "Naši merchandiseri pracujú s aplikáciou MERVIK, ktorá umožňuje online aj offline reporting priamo z predajne. Každá návšteva je zaznamenaná, každý problém zdokumentovaný — vrátane fotografie. Klient má prístup k dátam v reálnom čase, môže podávať reklamácie online a sledovať ich riešenie.",
      },
      symes: {
        eyebrow: "SYMES",
        title: "Vlastný dátový systém.",
        body:
          "Náš reportingový systém SYMES spracováva dáta zachytené cez mobilnú aplikáciu MERVIK. Výstupy sú dostupné v prehľadoch podľa EAN, predajne, reťazca, obchodnej jednotky alebo merchandisera.",
        bullets: [
          "Prehľad OOS výpadkov podľa EAN a zákazníka",
          "Opakované výpadky a počet dní v OOS statuse",
          "Audit plnenia plánogramu a cenových štítkov",
          "Fotodokumentácia promoakcií a in-store prezentácie",
        ],
      },
      qlik: {
        eyebrow: "QlikView",
        title: "Analytická platforma svetovej triedy.",
        body: [
          "Dáta majú hodnotu len vtedy, keď im rozumiete. Všetky instore dáta zo SYMES a MERVIK prenášame do platformy QlikView — jedného z najpokročilejších analytických nástrojov na svete, vyvinutého švédskou spoločnosťou Qlik.",
          "Kľúčovou vlastnosťou QlikView je asociatívny model dát, ktorý umožňuje prechádzať dáta voľne vo všetkých smeroch, nachádzať súvislosti a odpovedať na otázky, ktoré vopred nikto nepredpokladal.",
          "V prostredí QlikView zostavujeme pre každého klienta prehľadné dashboardy: dostupnosť produktov, vývoj OOS, plnenie plánogramu, cenové odchýlky, stav druhotných umiestnení aj prehľad POS komunikácie vlastnej aj konkurenčnej. Všetko filtrované podľa reťazca, predajne, regiónu, značky alebo časového obdobia.",
          "Žiadne zložité tabuľky v Exceli. Žiadne čakanie na report. Dáta sú k dispozícii okamžite, zrozumiteľne a pripravené na prezentáciu — či už pre váš obchodný tím, alebo pre rokovanie s retailerom.",
        ],
      },
      why: {
        eyebrow: "Prečo na tom záleží",
        title: "Nestačí vedieť, kde ste vy. Musíte vedieť, kde je konkurencia.",
        body:
          "Dodávateľ, ktorý prichádza na rokovanie s reťazcom s presnými dátami o dostupnosti, cenách, stave police, druhotných umiestneniach aj POS komunikácii — vlastnej aj konkurenčnej — argumentuje podloženými informáciami úplne inak ako dodávateľ, ktorý sa spolieha na pocity alebo oneskorené reporty. Instore dáta z našich systémov, vizualizované v QlikView, vám tieto argumenty dávajú k dispozícii každý deň.",
      },
      processIntro: {
        eyebrow: "Ako dáta zaznamenávame a spracovávame",
        title: "MERVIK · SYMES · QlikView — naše tri vrstvy.",
        sub: "Mobilný zber v teréne, vlastná dátová vrstva a svetová analytická platforma — tri prepojené nástroje, ktoré z každej návštevy robia dashboard.",
      },
    },
    cta: {
      eyebrow: "Začnite pri dátach",
      title: "Chcete vidieť vaše dáta v QlikView?",
      sub:
        "Pripravíme ukážkový dashboard na vašich dátach. Zadarmo a bez záväzkov.",
    },
  },
  shelfmasters: {
    hero: {
      eyebrow: "Pilier 03 / Shelfmasters",
      title: "Partnerstvo pre outsourcing retailovej exekúcie.",
      sub:
        "Zefektívnenie maloobchodných operácií pomocou špecializovaných externých terénnych tímov. Namiesto nákladného a nepružného interného obchodného tímu nasadzujeme tím retail execution špecialistov — s jednotnou metodikou, merateľnými KPI a zmluvne garantovanou kvalitou.",
      leadIn:
        "Strategické plánovanie a vyjednávanie s odberateľmi zostáva u vás. My preberáme každodenné prevedenie v teréne — a robíme to o desiatky percent lacnejšie a merateľne lepšie.",
    },
    benefits: {
      eyebrow: "Prečo Shelfmasters",
      title: "Štyri hlavné prínosy outsourcingu retailovej exekúcie.",
      items: [
        { kicker: "01", h: "Znížené fixné náklady", t: "Nižšie fixné mzdové náklady vďaka flexibilnému modelu — platíte za výsledok, nie za úväzok." },
        { kicker: "02", h: "Zvýšená flexibilita", t: "Kapacita sa prispôsobí sezónnym požiadavkám a obchodným potrebám — bez náboru a prepúšťania." },
        { kicker: "03", h: "Jednotná kvalita", t: "Rovnaké štandardy exekúcie naprieč všetkými predajňami a maloobchodnými kanálmi." },
        { kicker: "04", h: "Kontrola výkonu", t: "Viditeľnosť v reálnom čase a merateľný dohľad nad terénnymi operáciami." },
      ],
    },
    split: {
      eyebrow: "Rozdelenie zodpovedností",
      title: "Čo robíme my, čo si necháte vy.",
      intro:
        "Tento projekt preberá exekúciu a každodenný výkon — nie strategické obchodné vyjednávania. Strategické funkcie zostávajú pod vašou kontrolou.",
      gm: {
        h: "Global Marketing zaisťuje",
        items: [
          "Kontroly listingu a sortimentu",
          "Riadenie dostupnosti tovaru na regáloch (OSA)",
          "Umiestnenie produktov podľa plánogramov a plnenie dohôd s centrálami reťazcov",
          "Realizácia promo akcií",
          "Reporting a fotodokumentácia z predajní",
          "Komunikácia s personálom predajní a riešenie nedostatkov",
        ],
      },
      client: {
        h: "Klient si ponecháva",
        items: [
          "Rokovania s centrálami reťazcov",
          "Cenovú stratégiu a politiku",
          "Ročné rámcové dohody",
          "Plánovanie promo aktivít",
        ],
      },
    },
    ops: {
      eyebrow: "Prevádzkový rámec",
      title: "Komunikácia, reporting a výstupy pre klienta.",
      groups: [
        {
          h: "Komunikácia",
          items: [
            "Pravidelné status meetingy s kľúčovými stakeholdermi",
            "Mesačná business review",
            "Jasné pravidlá eskalácie pre riešenie problémov",
            "Presné podmienky a definície SLA",
          ],
        },
        {
          h: "Reporting & dátové systémy",
          items: [
            "Digitálny reporting cez mobilnú aplikáciu",
            "Fotodokumentácia z každej návštevy predajne",
            "Denné, týždenné a mesačné prehľady výkonnosti",
            "Identifikácia a riešenie problémov v reálnom čase",
          ],
        },
        {
          h: "Výstupy pre klienta",
          items: [
            "Prehľad plnenia podľa reťazcov",
            "Analýza podľa regiónu a predajní",
            "Akčné odporúčania na zlepšenie",
          ],
        },
      ],
    },
    phases: {
      eyebrow: "Plán implementácie",
      title: "Trojfázová implementácia.",
      intro:
        "Štruktúrovaný prístup zaisťuje hladký prechod z interného na externý model exekúcie.",
      items: [
        {
          n: "01",
          h: "Analýza a návrh",
          d: "Až 14 dní",
          list: [
            "Audit súčasného obchodného modelu klienta",
            "Identifikácia činností na prevod vs. zachovanie u klienta",
            "Návrh optimálneho modelu pokrytia",
          ],
        },
        {
          n: "02",
          h: "Pilotný program",
          d: "2–3 mesiace",
          list: [
            "Testovanie vo vybraných reťazcoch a regiónoch",
            "Stanovenie a kalibrácia kľúčových KPI",
            "Doladenie procesov a štruktúry reportingu",
          ],
        },
        {
          n: "03",
          h: "Roll-out",
          d: "Progresívny",
          list: [
            "Postupné nasadenie vo všetkých regiónoch, reťazcoch a predajniach",
            "Úplná náhrada interných tímov",
            "Úplné odovzdanie prevádzky",
          ],
        },
      ],
    },
    models: {
      eyebrow: "FTE vs. SLA",
      title: "Dva prístupy k terénnym operáciám.",
      intro:
        "Pochopenie zásadného rozdielu medzi tradičným obsadením pozícií a SLA modelom outsourcingu pokrytia.",
      fte: {
        h: "FTE model — interní zamestnanci",
        rows: [
          ["Nákladová štruktúra", "Platba za ľudí a ich platy"],
          ["Fixné náklady", "Predvídateľné, ale nepružné výdavky"],
          ["Riadenie", "Priamy dohľad nad jednotlivcami"],
          ["Hodnotenie", "Subjektívne posúdenie úsilia"],
          ["Zodpovednosť", "Ťažké vynucovanie sankcií"],
          ["Škálovateľnosť", "Náročná úprava kapacity"],
        ],
        tone: "tradičný model",
      },
      sla: {
        h: "SLA model — outsourcing pokrytia",
        rows: [
          ["Nákladová štruktúra", "Platba za dodané služby"],
          ["Variabilné náklady", "Zladené s aktuálnymi potrebami"],
          ["Riadenie", "Zameranie na výsledky a výstupy"],
          ["Hodnotenie", "Objektívne meranie dodávok"],
          ["Zodpovednosť", "Zmluvné pokuty a sankcie"],
          ["Škálovateľnosť", "Flexibilná úprava rozsahu"],
        ],
        tone: "odporúčaný prístup",
      },
      slaDef:
        "SLA definuje: aké výsledky musia byť dodané, v akej kvalite, ako často a aké sú dôsledky nedodržania. Mení retailovú exekúciu z personálnej výzvy na riadenú službu so zaručenými výsledkami.",
    },
    kpis: {
      eyebrow: "SLA — indikátory výkonu",
      title: "Čo meriame a ako často.",
      cols: ["#", "Oblasť výkonu", "Metrika SLA", "Metóda merania", "Frekvencia"],
      rows: [
        ["1", "Dostupnosť produktu", "On-Shelf-Availability (OSA)", "Foto + reporting", "Pri každej návšteve"],
        ["2", "Promo exekúcia", "Promo compliance", "Foto + checklist", "Deň zahájenia akcie + priebežne"],
        ["3", "Plánogram", "Planogram compliance", "Audit fotografií", "Mesačne"],
        ["4", "Coverage", "Plnenie plánu návštev", "GPS / log návštev", "Mesačne"],
        ["5", "Reporting", "Včasnosť reportingu", "Systémový log", "Pri každej návšteve"],
        ["6", "Kvalita exekúcie", "Kvalita vystavenia", "Audit", "Mesačne"],
        ["7", "Prevádzkový problém", "Doba odozvy na riešenie", "Podaná reklamácia", "Priebežne"],
      ],
    },
    reversibility: {
      eyebrow: "Reverzibilita",
      title: "Žiadny lock-in. Žiadna nenávratná investícia.",
      items: [
        { h: "Nízkonákladový návrat", t: "Návrat k pôvodnému modelu bez vysokých nákladov alebo nenávratných škôd." },
        { h: "Jednoduché ukončenie", t: "Externý tím môže byť ukončený s primeranou výpovednou lehotou." },
        { h: "Žiadna závislosť", t: "Zabraňuje závislosti od jedného konkrétneho riešenia alebo poskytovateľa." },
        { h: "Interné know-how zostáva", t: "Kritické procesy a operačné know-how zostávajú v rámci organizácie klienta." },
      ],
    },
    economics: {
      eyebrow: "Ekonomika projektu",
      title: "Konkrétne čísla. Konkrétna úspora.",
      intro: "Príklad: 10 obchodných zástupcov, 2 000 návštev mesačne.",
      fteCost: {
        h: "Náklady na 1 FTE (mesačne)",
        items: [
          ["Čistá mzda", "45 000 Kč"],
          ["Hrubá mzda (odhad)", "61 000 Kč"],
          ["Odvody zamestnávateľa (33,8 %)", "~21 000 Kč"],
          ["Mzdové náklady spolu", "82 000 Kč"],
          ["Operatívny lízing auta", "13 000 Kč"],
          ["Palivo (4 000 km)", "8 400 Kč"],
          ["Ostatné náklady na auto", "2 500 Kč"],
        ],
        total: "≈ 106 000 Kč / mesiac",
        footnote:
          "Nezahŕňa: manažérsky dohľad, nábor a zaškolenie, fluktuáciu, nemocenskú a dovolenku, IT vybavenie, mobilný telefón, benefity.",
      },
      compare: {
        h: "Cena za 1 návštevu",
        fte: { label: "FTE", value: "530 Kč", sub: "10 návštev/deň, 200/mesiac" },
        sla: { label: "SLA", value: "180 Kč", sub: "outsourcing" },
        delta: "−66 %",
        deltaLabel: "úspora na návštevu",
      },
      big: {
        eyebrow: "2 000 návštev mesačne",
        fte: { label: "Interný tím / 10× FTE", value: "1 060 000 Kč" },
        sla: { label: "SLA model", value: "360 000 Kč" },
        monthly: { label: "Úspora mesačne", value: "700 000 Kč" },
        yearly: { label: "Ročná úspora", value: "8 400 000 Kč" },
        claim: "SLA model prevádza fixné náklady na variabilné — ročná úspora 66 % oproti FTE modelu.",
      },
    },
    cta: {
      eyebrow: "Poďme spočítať váš case",
      title: "Koľko vás stojí súčasný model? Spočítame to spoločne.",
      sub:
        "Pošleme vám nezáväzný odhad úspory pre váš konkrétny rozsah — reťazce, počet predajní, frekvenciu návštev. Reálne čísla, žiadne prezentácie.",
      contact: {
        name: "Petr Bařina",
        email: "barina@globalmarketing.cz",
        phone: "+420 602 11 11 08",
        company: "Global Marketing s.r.o.",
      },
    },
  },

  form: {
    title: "Chcete vedieť viac? Ozvite sa nám.",
    name: "Meno a priezvisko",
    email: "Pracovný e-mail",
    company: "Spoločnosť",
    phone: "Telefón",
    message: "O čo máte záujem? (voliteľné)",
    submit: "Odoslať správu",
    submitting: "Odosielam…",
    successTitle: "Odoslané",
    success: "Ďakujeme. Ozveme sa do 24 hodín.",
    error: "Niečo sa nepodarilo, skúste to prosím znova.",
    requiredName: "Vyplňte prosím meno",
    requiredEmail: "Vyplňte prosím platný e-mail",
  },
  comingSoon: {
    title: "Stránka sa pripravuje.",
    sub: "Táto služba bude k dispozícii čoskoro. Medzitým preskúmajte sekciu Instore Data alebo nás kontaktujte.",
    cta: "Prejsť na Instore Data",
  },
  footer: {
    tagline: "Future of retail intelligence.",
    copy: "© Global Marketing. Všetky práva vyhradené.",
  },
  admin: {
    title: "Admin · Leady",
    tokenLabel: "Admin token",
    login: "Prihlásiť",
    logout: "Odhlásiť",
    empty: "Zatiaľ žiadne dopyty.",
    total: "Celkom",
    delete: "Vymazať",
    confirmDelete: "Naozaj vymazať tento záznam?",
  },
};
